export default "__VITE_ASSET__Bvc5nwLX__"